import { useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { NotesTextEditorHandle } from '@factorialco/f0-react/dist/experimental'
import { Tabs } from '@factorialco/f0-react/dist/experimental'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { MeetingNotes } from 'modules/meetings/components/MeetingNotes'

import { Transcript } from './components/Transcript'

export const SideBar = () => {
  const [activeTab, setActiveTab] = useState<'notes' | 'transcript'>('notes')
  const textEditorRef = useRef<NotesTextEditorHandle>(null)

  return (
    <>
      <Box paddingTop="s12">
        <Tabs
          activeTabId={activeTab}
          tabs={[
            {
              index: true,
              id: 'notes',
              label: i18n.t('meetings.room.sidebar.notes'),
              onClick: () => {
                track(trackingEvents.meetings.RoomOpenNotes)
                setActiveTab('notes')
              },
            },
            {
              id: 'transcript',
              label: i18n.t('meetings.room.sidebar.transcript'),
              onClick: () => {
                track(trackingEvents.meetings.RoomOpenTranscript)
                setActiveTab('transcript')
              },
            },
          ]}
        />
      </Box>
      {activeTab === 'transcript' && <Transcript />}
      <MeetingNotes
        textEditorRef={textEditorRef}
        hideNotes={activeTab !== 'notes'}
        meetingState="post"
      />
    </>
  )
}
